// Local translations
export const T = {
  en_GB: {
    heading: "MCP Servers",
    empty: "No MCP servers configured. Add one to extend the AI agent with external tools.",
    add: "Add",
    cancel: "Cancel",
    serverName: "Server name",
    urlPlaceholder: "URL (e.g. https://mcp.example.com)",
    noAuth: "No Auth",
    apiKeyLabel: "API Key",
    oauth: "OAuth",
    apiKeyPlaceholder: "API key",
    oauthHint: 'After adding, click "Connect" to authorize via OAuth.',
    addFailed: "Failed to add server",
    enable: "Enable",
    disable: "Disable",
    testConnection: "Test connection",
    delete: "Delete",
    resetFailures: "Re-enable and reset failure counter",
    connectOAuth: "Connect OAuth",
    reconnectOAuth: "Reconnect OAuth",
    connected: (count: string) => `Connected - ${count} tools found`,
    failed: "Failed",
    error: "Error",
  },
  nb_NO: {
    heading: "MCP-servere",
    empty:
      "Ingen MCP-servere konfigurert. Legg til én for å utvide AI-agenten med eksterne verktøy.",
    add: "Legg til",
    cancel: "Avbryt",
    serverName: "Servernavn",
    urlPlaceholder: "URL (f.eks. https://mcp.example.com)",
    noAuth: "Ingen autentisering",
    apiKeyLabel: "API-nøkkel",
    oauth: "OAuth",
    apiKeyPlaceholder: "API-nøkkel",
    oauthHint: 'Etter at du har lagt til, klikk "Koble til" for å autorisere via OAuth.',
    addFailed: "Kunne ikke legge til server",
    enable: "Aktiver",
    disable: "Deaktiver",
    testConnection: "Test tilkobling",
    delete: "Slett",
    resetFailures: "Aktiver på nytt og nullstill feiltelleren",
    connectOAuth: "Koble til OAuth",
    reconnectOAuth: "Koble til OAuth på nytt",
    connected: (count: string) => `Tilkoblet - ${count} verktøy funnet`,
    failed: "Mislyktes",
    error: "Feil",
  },
} as const;
